export const LAYOUT_SCREENS = {
	LARGE: 'LARGE',
	SMALL: 'SMALL',
}